import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, TransferState } from '@angular/core';

import { RouterModule } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { QRCodeComponent } from 'angularx-qrcode';
import { MaterialModule } from 'src/app/material/material.module';
import { ComboVariationDialogComponent } from 'src/app/shared/components/dialogs/combo-variation-dialog/combo-variation-dialog.component';
import { InfoDialogComponent } from 'src/app/shared/components/dialogs/info-dialog/info-dialog.component';
import { ProfileMenuComponent } from 'src/app/shared/components/profile-menu/profile-menu.component';
import { ProfileComponent } from 'src/app/shared/components/profile/profile.component';
import { ShowtimesErrorComponent } from 'src/app/shared/components/showtimes-error/showtimes-error.component';
import { ShowtimesComponent } from 'src/app/shared/components/showtimes/showtimes.component';
import { translateBrowserLoaderFactory } from 'src/app/shared/loader/translate-browser.loader.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BlockUiDialogComponent } from './components/dialogs/block-ui-dialog/block-ui-dialog.component';
import { ImageDialogComponent } from './components/dialogs/image-dialog/image-dialog.component';
import { MovieDialogComponent } from './components/dialogs/movie-dialog/movie-dialog.component';
import { QrDialogComponent } from './components/dialogs/qr-dialog/qr-dialog/qr-dialog.component';
import { SafetyGuidelinesDialogComponent } from './components/dialogs/safety-guidelines-dialog/safety-guidelines-dialog.component';
import { FooterComponent } from './components/footer/footer.component';
import { LoadingComponent } from './components/loading/loading.component';
import { MovieOperationDatesComponent } from './components/movie-operation-dates/movie-operation-dates.component';
import { MoviesSwiperComponent } from './components/movies-swiper/movies-swiper.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { DBoxGuidelinesContentComponent } from './components/safety-guidelines-content/d-box-guidelines-content/d-box-guidelines-content.component';
import { FourDxGuidelinesContentComponent } from './components/safety-guidelines-content/four-dx-guidelines-content/four-dx-guidelines-content.component';
import { PlayplusGuidelineContentComponent } from './components/safety-guidelines-content/playplus-guideline-content/playplus-guideline-content.component';
import { SnackbarComponent } from './components/snackbar/snackbar.component';
import { SwiperDirectiveDirective } from './directives/swiper-directive.directive';
import { NavComponent } from './components/nav/nav/nav.component';
import { ProfileItemsEmptyComponent } from './components/profile-items-empty/profile-items-empty.component';
import { AddFavCinemaComponent } from './components/add-fav-cinema/add-fav-cinema.component';
import { RegionFiltersComponent } from './components/dialogs/region-filters/region-filters.component';
import { MovieRatingsGuidelinesDialogComponent } from './components/dialogs/movie-ratings-guidelines-dialog/movie-ratings-guidelines-dialog.component';
import { SeatTypeDialogComponent } from './components/dialogs/seat-type-dialog/seat-type-dialog.component';
import { ProductHighlightDialogComponent } from './components/dialogs/product-highlight-dialog/product-highlight-dialog.component';
import { RewardsRedemptionComponent } from './components/dialogs/rewards-redemption/rewards-redemption.component';
import { BannerComponent } from './components/banner/banner.component';
import { GuestEditInfoDialogComponent } from './components/dialogs/guest-edit-info-dialog/guest-edit-info-dialog.component';
import { InvalidDisplayComponent } from './components/invalid-diplay/invalid-display.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { OnboardingDialogComponent } from './components/dialogs/onboarding-dialog/onboarding-dialog.component';
import { UnlockTierDialogComponent } from './components/dialogs/unlock-tier-dialog/unlock-tier-dialog.component';
import { PasswordValidationDialogComponent } from './components/dialogs/password-validation-dialog/password-validation-dialog.component';
import { SpecialScreeningImageDialogComponent } from './components/dialogs/special-screening-image-dialog/special-screening-image-dialog.component';

@NgModule({
    declarations: [
        BlockUiDialogComponent,
        ComboVariationDialogComponent,
        FooterComponent,
        ImageDialogComponent,
        InfoDialogComponent,
        LoadingComponent,
        MovieDialogComponent,
        MoviesSwiperComponent,
        NavbarComponent,
        SnackbarComponent,
        SwiperDirectiveDirective,
        SafetyGuidelinesDialogComponent,
        PlayplusGuidelineContentComponent,
        FourDxGuidelinesContentComponent,
        DBoxGuidelinesContentComponent,
        QrDialogComponent,
        ShowtimesComponent,
        MovieOperationDatesComponent,
        NavComponent,
        ProfileComponent,
        ProfileMenuComponent,
        ShowtimesErrorComponent,
        ProfileItemsEmptyComponent,
        AddFavCinemaComponent,
        RegionFiltersComponent,
        MovieRatingsGuidelinesDialogComponent,
        SeatTypeDialogComponent,
        ProductHighlightDialogComponent,
        RewardsRedemptionComponent,
        BannerComponent,
        GuestEditInfoDialogComponent,
        InvalidDisplayComponent,
        OnboardingDialogComponent,
        SpecialScreeningImageDialogComponent,
    ],
    imports: [
        CommonModule,
        MaterialModule,
        RouterModule,
        MatProgressSpinnerModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: translateBrowserLoaderFactory,
                deps: [HttpClient, TransferState],
            },
        }),
        QRCodeComponent,
        FormsModule,
        ReactiveFormsModule,
    ],
    exports: [
        FooterComponent,
        LoadingComponent,
        MoviesSwiperComponent,
        NavbarComponent,
        InfoDialogComponent,
        TranslateModule,
        ShowtimesComponent,
        MovieOperationDatesComponent,
        NavComponent,
        ProfileComponent,
        ProfileMenuComponent,
        QRCodeComponent,
        ShowtimesErrorComponent,
        ProfileItemsEmptyComponent,
        BannerComponent,
        GuestEditInfoDialogComponent,
        InvalidDisplayComponent,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule { }
